import AideDomicileHero from './components/AideDomicileHero';
import AideDomicileServices from './components/AideDomicileServices';
import AideDomicileProcess from './components/AideDomicileProcess';
import AideDomicileCTA from './components/AideDomicileCTA';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Aide à Domicile Neuenegg - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Meyrin",
      "addressRegion": "Genève",
      "addressCountry": "CH"
    }
  },
  "areaServed": ["Genève", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Services d'aide à domicile à Genève et en Suisse romande. Petits travaux, entretien, assistance aux particuliers.",
  "serviceType": "Aide à domicile",
  "url": `${import.meta.env.VITE_SITE_URL}/aide-domicile`
};

export default function AideDomicilePage() {
  return (
    <>
      <SEOHead
        title="Aide à Domicile Neuenegg | Services aux Particuliers Suisse Romande - CasaReNovaPlus"
        description="CasaReNovaPlus : aide à domicile à Neuenegg et en Suisse romande. Petits travaux, entretien, assistance aux particuliers. Service fiable et professionnel. Devis gratuit."
        keywords="aide à domicile Genève, services particuliers Genève, petits travaux Genève, assistance domicile Suisse romande, bricolage Genève, entretien maison Genève"
        canonical={`${import.meta.env.VITE_SITE_URL}/aide-domicile`}
        schema={schema}
      />
      <Header />
      <main>
        <AideDomicileHero />
        <AideDomicileServices />
        <AideDomicileProcess />
        <AideDomicileCTA />
      </main>
      <Footer />
    </>
  );
}
